import { cn } from "@/lib/utils";
import perseonLabsMark from "@/assets/perseon-labs-mark.png";

interface BrandMarkProps {
  className?: string;
}

// Official Perseon Labs crest (perseonlabs.io header mark) — displayed as-is,
// no wrapper background, since the artwork carries its own colours.
const BrandMark = ({ className }: BrandMarkProps) => (
  <img
    src={perseonLabsMark}
    alt="Perseon Labs"
    className={cn("h-9 w-9 flex-shrink-0 rounded-lg object-contain", className)}
  />
);

export default BrandMark;
